import React from "react";
import { Link } from 'react-router-dom'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
// import image1 from "assets/img/career.jpeg";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <CardBody>
                  {/* <center>
                    <img src={image1} alt="Career" style={{ width: 500, height: 250, marginRight: 25 }} />
                  </center> <br /> */}
                  <span style={{ marginBottom: 0 }}><b>December 10, 2018</b></span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>ISO 37001 CONSULTANT</b></h2>
                  <p style={{ fontSize: 18 }}>
                    <b>
                      Specific Responsibilities
                      </b>
                  </p>
                  <ul>
                    <li>Assist senior consultants in the project documentation process</li>
                    <li>Create and coordinate the schedule of visiting consultants</li>
                    <li>Detailed understanding of ISO material and company products</li>
                    <li>Provide training according to the material and schedule provided</li>
                    <li>Coordinate and prepare data relating to customer audits</li>
                    <li>Make material reports and training results and audits according to the dateline</li>
                  </ul>
                  <p style={{ fontSize: 18 }}>
                    <b>
                      Profile
                    </b>
                  </p>
                  <ul>
                    <li>Bachelor/University degree in any field</li>
                    <li>Minimum age of 25</li>
                    <li>Experience in Anti-Bribery Management Systems ISO 37001</li>
                    <li>Minimum 3 years’ experience in fields related to management systems, processes and practices across a range of industries and ISO certification</li>
                    <li>Preferably for those who have certification as Lead Auditor by IRCA or any equivalent institution for ISO 37001: 2016</li>
                    <li>Having experience in auditing systems and procedures</li>
                    <li>Ready to travel to all regions of Indonesia</li>
                    <li>Responsible</li>
                  </ul>
                  <p style={{ fontSize: 18 }}>
                    <b>
                      Required Skills
                    </b>
                  </p>
                  <ul>
                    <li>Excellent analytic and negotiation skills </li>
                    <li>Good communication and interpersonal skills </li>
                    <li>Proven ability with Microsoft Word, Power Point, Excel Spreadsheet, and other required application.</li>
                    <li>Ability to read, write, and speak English fluently</li>
                    <li>Logical approach to problem solving</li>
                  </ul>
                  <p>Please send your complete application and CV to <Link to="#"><b>hrd@sandtonglobal.com</b></Link></p>
                  <br />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/CareerPage/Sections/ProductSection.1.jsx